export default "__VITE_ASSET__DERLG2HE__"